export const getPlatformInfo = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) return 'android';
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return 'ios';
    return 'web';
};

export const getBrowserInfo = () => {
    return {
        device_brand: navigator.vendor || 'unknown',
        device_model: navigator.userAgent || 'unknown',
        device_os_version: navigator.platform || 'unknown',
    };
};

export const getLocalDateTime = () => {
    return new Date().toLocaleString('en-IN', {
        timeZone: 'Asia/Kolkata',
        hour12: true,
    });
};
